export function getSecrets() {
  // DO NOT put any confidential secret here
  const NODE_ENV = process.env.NODE_ENV;
  const DAPP_DOMAIN = process.env.DAPP_DOMAIN;
  const DASHBOARD_DOMAIN = process.env.DASHBOARD_DOMAIN;
  const BACKEND_URL = process.env.BACKEND_URL;
  const ANALYTICS_URI = process.env.ANALYTICS_URI;
  const AUTH_SERVER_URL = process.env.AUTH_SERVER_URL;
  const INFURA_PROJECT_SECRET = process.env.INFURA_PROJECT_SECRET;
  const INFURA_PROJECT_ID = process.env.INFURA_PROJECT_ID;
  const WALLET_CONNECT_PROJECT_ID = process.env.WALLET_CONNECT_PROJECT_ID;
  const MARKET_CONTRACT = process.env.MARKET_CONTRACT;
  const DELEGATE_CONTRACT = process.env.DELEGATE_CONTRACT;
  const USDC_CONTRACT = process.env.USDC_CONTRACT;
  const ETH_CONTRACT = process.env.ETH_CONTRACT;
  const RPC_ENDPOINT = process.env.RPC_ENDPOINT;
  const EASTEREGG_CHAIN_ID = process.env.EASTEREGG_CHAIN_ID;
  const EASTEREGG_CONTRACT = process.env.EASTEREGG_CONTRACT;
  const ETH_TAIPEI_CHAIN_ID = process.env.ETH_TAIPEI_CHAIN_ID;
  const ETH_TAIPEI_CONTRACT = process.env.ETH_TAIPEI_CONTRACT;
  const USDT_CONTRACT = process.env.USDT_CONTRACT;
  const MARKET_CONTRACT_MATIC = process.env.MARKET_CONTRACT_MATIC;
  const DELEGATE_CONTRACT_MATIC = process.env.DELEGATE_CONTRACT_MATIC;
  const MATIC_CONTRACT = process.env.MATIC_CONTRACT;
  const ETH_CONTRACT_MATIC = process.env.ETH_CONTRACT_MATIC;
  const USDC_CONTRACT_MATIC = process.env.USDC_CONTRACT_MATIC;
  const USDT_CONTRACT_MATIC = process.env.USDT_CONTRACT_MATIC;
  const LOGO_BASE_URL = process.env.LOGO_BASE_URL;
  const BACKGROUND_IMAGE_BASE_URL = process.env.BACKGROUND_IMAGE_BASE_URL;
  const DAPP_IMAGE_BASE_URL = process.env.DAPP_IMAGE_BASE_URL;
  const BACKGROUND_IMAGE_GLOBAL_URL = process.env.BACKGROUND_IMAGE_GLOBAL_URL;
  const CLOUDFRONT_BASE_URL = process.env.CLOUDFRONT_BASE_URL;
  const ENS_ADDRESS = process.env.ENS_ADDRESS;
  const OPENSEA_LINK = process.env.OPENSEA_LINK;
  const OPENSEA_LINK_MATIC = process.env.OPENSEA_LINK_MATIC;
  const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
  const REDIRECT_URI = process.env.REDIRECT_URI;
  const DAPP_URI = process.env.DAPP_URI;
  const IMGPROXY_BASE_URL = process.env.IMGPROXY_BASE_URL;
  const ASSETS_BASE_URL = process.env.ASSETS_BASE_URL;
  const GAME_URI = process.env.GAME_URI;
  const STRIPE_PUBLISH_KEY = process.env.STRIPE_PUBLISH_KEY;

  return {
    NODE_ENV,
    DAPP_DOMAIN,
    DASHBOARD_DOMAIN,
    BACKEND_URL,
    ANALYTICS_URI,
    AUTH_SERVER_URL,
    INFURA_PROJECT_SECRET,
    INFURA_PROJECT_ID,
    WALLET_CONNECT_PROJECT_ID,
    MARKET_CONTRACT,
    DELEGATE_CONTRACT,
    USDC_CONTRACT,
    ETH_CONTRACT,
    RPC_ENDPOINT,
    EASTEREGG_CHAIN_ID,
    EASTEREGG_CONTRACT,
    ETH_TAIPEI_CHAIN_ID,
    ETH_TAIPEI_CONTRACT,
    USDT_CONTRACT,
    MARKET_CONTRACT_MATIC,
    DELEGATE_CONTRACT_MATIC,
    MATIC_CONTRACT,
    ETH_CONTRACT_MATIC,
    USDC_CONTRACT_MATIC,
    USDT_CONTRACT_MATIC,
    LOGO_BASE_URL,
    BACKGROUND_IMAGE_BASE_URL,
    DAPP_IMAGE_BASE_URL,
    BACKGROUND_IMAGE_GLOBAL_URL,
    CLOUDFRONT_BASE_URL,
    ENS_ADDRESS,
    OPENSEA_LINK,
    OPENSEA_LINK_MATIC,
    GOOGLE_CLIENT_ID,
    REDIRECT_URI,
    DAPP_URI,
    IMGPROXY_BASE_URL,
    ASSETS_BASE_URL,
    GAME_URI,
    STRIPE_PUBLISH_KEY,
  };
}
export function getFeatures() {
  // DO NOT put any confidential secret here
  const FEATURE_NFT_LIST_ENABLED =
    process.env.FEATURE_NFT_LIST_ENABLED === "true";

  const FEATURE_PWA_ENABLED = process.env.FEATURE_PWA_ENABLED === "true";
  const FEATURE_ERROR_RENDER_ENABLED =
    process.env.FEATURE_ERROR_RENDER_ENABLED === "true";

  const FEATURE_USER_ANALYSIS_ENABLED =
    process.env.FEATURE_USER_ANALYSIS_ENABLED === "true";

  const FEATURE_DM_Contact_ENABLED =
    process.env.FEATURE_DM_Contact_ENABLED === "true";

    const FEATURE_SUPER_CHAT_HISTORY_ENABLED =
    process.env.FEATURE_SUPER_CHAT_HISTORY_ENABLED === "true";

  const FEATURE_REDEEM_LIST_ENABLED =
    process.env.FEATURE_REDEEM_LIST_ENABLED === "true";

  const FEATURE_FOLLOW_ENABLED = process.env.FEATURE_FOLLOW_ENABLED === "true";

  const FEATURE_ENHANCER_REPLY_ENABLED = process.env.FEATURE_ENHANCER_REPLY_ENABLED === "true";


  return {
    FEATURE_NFT_LIST_ENABLED,
    FEATURE_PWA_ENABLED,
    FEATURE_ERROR_RENDER_ENABLED,
    FEATURE_USER_ANALYSIS_ENABLED,
    FEATURE_DM_Contact_ENABLED,
    FEATURE_REDEEM_LIST_ENABLED,
    FEATURE_FOLLOW_ENABLED,
    FEATURE_ENHANCER_REPLY_ENABLED,
    FEATURE_SUPER_CHAT_HISTORY_ENABLED
  };
}
